import {
    APP_EMAIL_TEMPLATE_LIST,
    APP_INSTANCE_EMAIL_TEMPLATE_LIST,
    GET_APP_EMAIL_TEMPLATE_LIST,
    HIDE_LOADING,
    SET_ADD_EDIT,
    SHOW_LOADING,
    EMAIL_TEMPLATE_MESSAGE,
  } from "redux/constants/template";
  
  const initState = {
    loading: true,
    addEditValue : false,
    templates: [],
    instanceTemplates:[],
    permissions : localStorage.getItem("permissions")!==""?JSON.parse(localStorage.getItem("permissions")):"",
  };
  
  const app = (state = initState, action) => {
    switch (action?.type) {
        case APP_EMAIL_TEMPLATE_LIST:
            return {
              ...state,
              templates: action.payload,
              addEditValue:false,
              allowRedirect: false,
              loading: false,
              message: "",
            };
        case APP_INSTANCE_EMAIL_TEMPLATE_LIST:
            return {
                ...state,
              instanceTemplates: action.payload,
              addEditValue:false,
              allowRedirect: false,
              loading: false,
              message: "",
            }
        case EMAIL_TEMPLATE_MESSAGE:
            return {
                ...state,
                message: messageRead(action),
                status: action?.response?.status,
                showMessage: true,
                loading: false,
              };
        case SHOW_LOADING: {
            return {
                ...state,
                loading: true,
            };
            }
        case HIDE_LOADING: {
        return {
            ...state,
            loading: false,
        };
        }
        case SET_ADD_EDIT:
            return {
              ...state,
              addEditValue: action.addEditValue,
              loading: false,
              appRolePermissions: [],
            };
      default:
        return state;
    }
  };
  
  const messageRead=(action)=>{
    if(action?.response?.status==401 || action?.response?.response?.status){
      return "Unauthorized"
    }
      if(action?.response && action?.response?.response && action?.response?.response?.data && action?.response?.response?.message){
       return action?.response?.response?.data?.message;
      }else if(action?.response && action?.response?.data && action?.response?.data?.message){
          return action?.response?.data?.message;
      }else if(action?.response && action?.response?.data && action?.response?.data?.message){
          return action?.response?.data?.message;
      }else if(action?.data?.message){
          return action?.data?.message;
      }else if(action?.data){
          return action?.data;
      }else{
          return "something went wrong"
      }
  }
  
  export default app;
  